import React from "react";
import {Result, Typography} from "antd";

interface Props {
    extra?: React.ReactNode
}

const Error500 = ({extra}: Props) => {
    return (
        <Result
            status="500"
            title="500"
            subTitle={<p>Sorry, something went wrong. Please contact <Typography.Link href='mailto:rio@sfu.ca'>rio@sfu.ca</Typography.Link> for more information.</p>}
            extra={extra}
        />
    )
};

export default Error500;